module.exports = __webpack_public_path__ + "img/ladislav.39a98583.png";